export default __webpack_public_path__ + "alberta-size.aaf4a1e7ef5ee1503feb.svg";